import { render, staticRenderFns } from "./b13.vue?vue&type=template&id=a1940c8e&scoped=true"
import script from "./b13.vue?vue&type=script&lang=js"
export * from "./b13.vue?vue&type=script&lang=js"
import style0 from "./b13.vue?vue&type=style&index=0&id=a1940c8e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1940c8e",
  null
  
)

export default component.exports